import { Floorplan } from "@domain/project/floorplan/floorplan";
import { FloorplanEventType } from "@domain/project/floorplan/floorplan-event";
import { FloorplanNode } from "@domain/project/floorplan/floorplan-node";
import { FloorplanTransmitter } from "@domain/project/floorplan/floorplan-transmitter";
import { FloorplanTransmitterPlaceholder } from "@domain/project/floorplan/floorplan-transmitter-placeholder";
import { Exclude, Expose } from "class-transformer";
import { IsNumber, IsUUID } from "class-validator";

export class FloorplanRemoteSensor extends FloorplanNode {
  @IsUUID()
  public readonly id: string;

  @Exclude()
  protected _floorplan!: Floorplan;

  @Exclude()
  protected _transmitter!: FloorplanTransmitter | FloorplanTransmitterPlaceholder;

  @Expose({ name: "size" })
  @IsNumber()
  private _size: number;

  constructor(
    floorplan: Floorplan,
    transmitter: FloorplanTransmitter | FloorplanTransmitterPlaceholder,
    id: string,
    x: number,
    y: number,
    size: number,
  ) {
    super(x, y);
    this.id = id;
    this._size = size;
    this._floorplan = floorplan;
    this._transmitter = transmitter;
  }

  init(floorplan: Floorplan, transmitter: FloorplanTransmitter | FloorplanTransmitterPlaceholder) {
    this._floorplan = floorplan;
    this._transmitter = transmitter;
  }

  get size() {
    return this._size;
  }

  set size(size: number) {
    this._size = size;
  }

  updateSize(value: number, x: number, y: number) {
    this._size = value;
    this.updatePosition(x, y);
  }

  override updatePosition(x: number, y: number) {
    super.updatePosition(x, y);
    this._floorplan.publishUpdate(FloorplanEventType.ITEM_UPDATED, this);
  }

  override get locked(): boolean {
    return this._transmitter.locked;
  }
}
